var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 3.33366C3.11199 3.33366 2.90003 3.42146 2.74375 3.57774C2.58747 3.73402 2.49967 3.94598 2.49967 4.16699V15.8337C2.49967 16.0547 2.58747 16.2666 2.74375 16.4229C2.90003 16.5792 3.11199 16.667 3.33301 16.667H16.6663C16.8874 16.667 17.0993 16.5792 17.2556 16.4229C17.4119 16.2666 17.4997 16.0547 17.4997 15.8337V6.66699C17.4997 6.44598 17.4119 6.23402 17.2556 6.07774C17.0993 5.92146 16.8874 5.83366 16.6663 5.83366H9.16634C8.88771 5.83366 8.62752 5.69441 8.47297 5.46258L7.05369 3.33366H3.33301ZM1.56524 2.39923C2.03408 1.93038 2.66997 1.66699 3.33301 1.66699H7.49967C7.7783 1.66699 8.0385 1.80624 8.19305 2.03808L9.61233 4.16699H16.6663C17.3294 4.16699 17.9653 4.43038 18.4341 4.89923C18.9029 5.36807 19.1663 6.00395 19.1663 6.66699V15.8337C19.1663 16.4967 18.9029 17.1326 18.4341 17.6014C17.9653 18.0703 17.3294 18.3337 16.6663 18.3337H3.33301C2.66997 18.3337 2.03408 18.0703 1.56524 17.6014C1.0964 17.1326 0.833008 16.4967 0.833008 15.8337V4.16699C0.833008 3.50395 1.0964 2.86807 1.56524 2.39923Z",
    fill: "#FCBF04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.58316f0c91d89f2626a352c8ff255c4a.svg";
export { ForwardRef as ReactComponent };